import Store from 'redux/store';
import {
  FETCH_CMS_STATIC,
  FETCH_CMS_STATIC_FAIL,
  FETCH_CMS_STATIC_SUCCESS,
} from 'redux/Reducers/CmsStatic/CmsStaticReducer';
import { CMSEndpoint } from '../clients';

/* eslint-disable */
const FetchCmsStatic = async (User, finallyCallback = () => { }, { segment }) => {
  Store.dispatch({ type: FETCH_CMS_STATIC });
  CMSEndpoint(User).get(`/${segment}/content`).then((response) => {
    Store.dispatch({
      type: FETCH_CMS_STATIC_SUCCESS,
      payload: {
        ...response,
      },
    });
  }).catch((e) => {
    Store.dispatch({
      type: FETCH_CMS_STATIC_FAIL,
      error: e,
    });
  })
    .finally(() => {
      finallyCallback();
    });
};
export default FetchCmsStatic;
